module.exports = __webpack_public_path__ + "img/patient_kol-1.eb9f15a2.png";